(function () {
  var currentGallery = null;

  function computeFitRatio(item) {
    var w = parseFloat(item.w) || 1;
    var h = parseFloat(item.h) || 1;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    return Math.min(vw / w, vh / h);
  }

  function patchGetImageData() {
    if (!window.theme || !theme.Photoswipe || !theme.Photoswipe.prototype.getImageData) {
      return false;
    }
    if (theme.Photoswipe.prototype.getImageData.__zoomFixPatched) {
      return true;
    }
    var proto = theme.Photoswipe.prototype;
    var originalGetImageData = proto.getImageData;
    var patched = function () {
      var items = originalGetImageData.call(this);
      items.forEach(function (item) {
        item.initialZoomLevel = computeFitRatio(item);
      });
      return items;
    };
    patched.__zoomFixPatched = true;
    proto.getImageData = patched;
    return true;
  }

  function patchInitGallery() {
    if (!window.theme || !theme.Photoswipe || !theme.Photoswipe.prototype.initGallery) {
      return false;
    }
    if (theme.Photoswipe.prototype.initGallery.__zoomFixPatched) {
      return true;
    }
    var proto = theme.Photoswipe.prototype;
    var originalInitGallery = proto.initGallery;
    var patched = function (items, index) {
      originalInitGallery.call(this, items, index);
      currentGallery = this.gallery;
      forceCorrectFit(this.gallery);
      setupZoomSlider();
      this.gallery.listen('destroy', function () {
        if (currentGallery === this) {
          currentGallery = null;
        }
      }.bind(this.gallery));
    };
    patched.__zoomFixPatched = true;
    proto.initGallery = patched;
    return true;
  }

  function forceCorrectFit(gallery) {
    if (!gallery) {
      return;
    }
    function applyFit() {
      if (currentGallery !== gallery) {
        return;
      }
      var item = gallery.currItem;
      if (!item) {
        return;
      }
      var fit = computeFitRatio(item);
      item.initialZoomLevel = fit;
      var pswpElement = document.querySelectorAll('.pswp')[0];
      if (!pswpElement) {
        return;
      }
      var rect = pswpElement.getBoundingClientRect();
      var center = { x: rect.width / 2, y: rect.height / 2 };
      gallery.zoomTo(fit, center, 0);
    }
    // Run after the opening transition and after layout has fully settled
    // (mobile browsers can report a smaller container size before the
    // address bar collapses, which throws off PhotoSwipe's own fit calc).
    setTimeout(applyFit, 0);
    setTimeout(applyFit, 350);
    gallery.listen('afterChange', function () {
      setTimeout(applyFit, 0);
    });
  }

  function zoomRangeForItem(item) {
    var min = item.initialZoomLevel || computeFitRatio(item);
    var max = Math.max(min * 3, 1);
    return { min: min, max: max };
  }

  function zoomFromSlider(evt) {
    var gallery = currentGallery;
    if (!gallery || !gallery.currItem) {
      return;
    }
    var slider = evt.target;
    var range = zoomRangeForItem(gallery.currItem);
    var pct = parseFloat(slider.value) / 100;
    var zoomLevel = range.min + (range.max - range.min) * pct;
    var pswpElement = document.querySelectorAll('.pswp')[0];
    var rect = pswpElement.getBoundingClientRect();
    var center = { x: rect.width / 2, y: rect.height / 2 };
    gallery.zoomTo(zoomLevel, center, 0);
  }

  function setupZoomSlider() {
    var slider = document.querySelector('.pswp__zoom-slider');
    if (!slider) {
      return;
    }

    if (!slider.__zoomFixWired) {
      slider.addEventListener('input', zoomFromSlider);
      slider.__zoomFixWired = true;
    }

    slider.value = 0;
    if (currentGallery) {
      currentGallery.listen('afterChange', function () {
        slider.value = 0;
      });
    }
  }

  function patchAll() {
    var a = patchGetImageData();
    var b = patchInitGallery();
    return a && b;
  }

  if (!patchAll()) {
    document.addEventListener('DOMContentLoaded', patchAll);
  }
})();
